export const getProxyAPI = () => {
  return JSON.parse(localStorage.getItem('model_config'))?.baseUrl || '';
};
export const getPublicToken = () => {
  return JSON.parse(localStorage.getItem('model_config'))?.publicToken || '';
};
